export const EXIT_WITHOUT_SAVING_MODAL_TEST_ID = 'exit-without-saving-modal';
export const SAVING_BEFORE_EXIT_MODAL_TEST_ID = 'saving-before-exit-modal';
export const STEP_NUMBER_TEST_ID = 'step-number';
